import DispositivosMedicosLayout from '@/views/dispositivos-medicos/Layout.vue'
import DispositivosMedicosDashboard from '@/views/dispositivos-medicos/Dashboard.vue'

export default [
    {
        path: '/dm',
        component: DispositivosMedicosLayout,
        meta: {
            requiresAuth: true,
            permiso: 'dm',
            title: 'Dispositivos Médicos | Suizo Argentina',
            description: 'Sistema de Dispositivos Médicos - Suizo Argentina'
        },
        children: [
            {
                path: 'dashboard',
                name: 'dm-dashboard',
                component: DispositivosMedicosDashboard,
                meta: {
                    requiresAuth: true,
                    permiso: 'dm',
                    title: 'Dashboard Dispositivos Médicos | Suizo Argentina',
                    description: 'Dashboard principal del sistema de Dispositivos Médicos'
                }
            },
            {
                path: 'registros',
                name: 'dm-registros',
                component: () => import('@/views/dispositivos-medicos/Registros.vue'),
                meta: {
                    requiresAuth: true,
                    permiso: 'dm',
                    title: 'Registros Dispositivos Médicos | Suizo Argentina',
                    description: 'Gestión de registros de dispositivos médicos'
                }
            },
            {
                path: 'medicos',
                name: 'dm-medicos',
                component: () => import('@/views/dispositivos-medicos/Medicos.vue'),
                meta: {
                    requiresAuth: true,
                    permiso: 'dm',
                    title: 'Médicos Dispositivos Médicos | Suizo Argentina',
                    description: 'Gestión de médicos y profesionales de dispositivos médicos'
                }
            },
            {
                path: 'pruebas',
                name: 'dm-pruebas',
                component: () => import('@/views/dispositivos-medicos/Pruebas.vue'),
                meta: {
                    requiresAuth: true,
                    permiso: 'dm',
                    title: 'Pruebas Dispositivos Médicos | Suizo Argentina',
                    description: 'Sistema de pruebas para dispositivos médicos'
                }
            },
            {
                path: '',
                redirect: 'dashboard'
            }
        ]
    }
] 